module.exports = __webpack_public_path__ + "img/emoji-suitcase@3x.35f80e7.png";